import React from 'react';

const MessagesError = ({ error, setError }) => {
  const cleanAlert = () => {
    console.log('clean');
    setError('');
  };

  return (
    <div
      className="bg-red-100 text-center py-4 lg:px-4 cursor-pointer absolute top-0 w-full z-10"
      onClick={cleanAlert}
    >
      <div
        className="p-2 bg-red-100 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
        role="alert"
      >
        <span className="flex rounded-full bg-red-900 uppercase px-2 py-1 text-xs font-bold mr-3">
          Error
        </span>
        <span className="font-semibold mr-2 text-left flex-auto text-blue-900">
          {error}
        </span>
        <svg
          className="fill-current opacity-75 h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
        </svg>
      </div>
    </div>
  );
};

export default MessagesError;
